import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import { AppMediaQuery, Button, Text } from "ui-components";

import AccountLinks from '@common/components/AccountLinks';
import AppHeader from "@common/components/AppHeader";
import AssessmentSelection from "./AssessmentSelection";

import {
  LandingActions,
  LandingContentWrapper,
  LandingContent,
  LandingWrapper
} from "./styled";

class Landing extends Component {
  state = {
    assessmentTool: null
  };

  /**
   * Handle the Next button click to proceed to the selected tool (uses React Router history prop)
   */
  onNextClick = () => {
    if (this.state.assessmentTool) {
      // Update the browser history
      this.props.history.push(`/${this.state.assessmentTool}`);
    }
  };

  /**
   * Handle the Select field change and update the selected assessment tool
   * @param  {object} e     Event object
   * @param  {int}    index Selected index
   * @param  {string} value Selected value
   */
  onAssessmentChange = (e, index, value) => {
    this.setState({
      assessmentTool: value
    });
  };

  render() {
    const pshsaLink = (
      <a href="//www.pshsa.ca/products/assessing-violence-in-the-community-a-handbook-for-the-workplace/">
        Assessing Violence in the Community: A Handbook for the Workplace,
      </a>
    );

    return (
      <LandingWrapper>
        <Helmet>
          <title>E-Forms Landing</title>
        </Helmet>
        <AppHeader />
        <AppMediaQuery>
          <LandingContentWrapper>
            <LandingContent>
              <Text size={2} type="medium" color="maroon" marginV={3}>
                Community Assessment Tools
              </Text>
              <Text type="book" marginV={4}>
                <Text marginV={2}>
                  Violence in the workplace is a growing issue in the
                  healthcare sector. Staff who make home visits are at
                  particular risk for violence due to unpredictability of the
                  environment and having to travel within the community.
                </Text>
                <Text marginV={2}>
                  It is critical that employee safety is considered a priority
                  and that appropriate assessments of the client, community
                  and environment are conducted to recognize and control
                  potential hazards.
                </Text>
                <Text marginV={2}>
                  Based on the PSHSA booklet
                  {" "}
                  {pshsaLink}
                  {" "}
                  the following e-tools
                  can help you get started. The tools are designed to guide
                  you through the assessment process of three elements that
                  should be considered to prevent or minimize the risk of
                  workplace violence for those who work in the community.
                  Each tool includes useful tips and guidelines to support
                  proactive health and safety action planning.
                </Text>
              </Text>
              <LandingActions>
                <AssessmentSelection
                  value={this.state.assessmentTool}
                  onChange={this.onAssessmentChange}
                />
                <Button
                  xlarge
                  onClick={this.onNextClick}
                  disabled={!this.state.assessmentTool}
                  style={{ marginTop: "30px" }}
                >
                  Next
                </Button>
              </LandingActions>
              <AccountLinks style={{ marginBottom: "30px" }} />
            </LandingContent>
          </LandingContentWrapper>
        </AppMediaQuery>
      </LandingWrapper>
    );
  }
}

export default withRouter(Landing);



// WEBPACK FOOTER //
// ./src/landing/Landing.jsx